<template>
    <div style="display:inline"> 
        <div v-if="inline !== true" class="row">
            <div class="col col-12 text" style="margin-top:20px">
                <small style="font-size:12px;"><i class="bi bi-info-circle"></i> {{prompt}}</small>
                <br/>
                <vue3-icon-picker @update:renderedIcon="OnIconChange" :renderedIcon="icon.Icon" :renderedColor="icon.Color" :renderedSize="icon.Size" />
            </div>
            <hr style="margin-top: 5px; margin-bottom:5px;" />
        </div>
        
        <vue3-icon-picker v-if="inline === true" @update:renderedIcon="OnIconChange" :renderedIcon="icon.Icon" :renderedColor="IconColor" :renderedSize="icon.Size" />
        
    </div>
</template>

<style>
</style>


<script>
    import Vue3IconPicker from '/src/components/IconPicker.vue';

    export default {
        name: 'propertyiconeditor',
        emits: ['update:icon'],
        components: { Vue3IconPicker, },
        props: {
            "inline": Boolean,
            "icon": Object,
            "prompt": String
        },
        data() {
            return {     
                IconColor: ''
            };
        },
        methods:
        {
            OnIconChange(dat) {
                this.IconColor = dat.color;
                this.$emit("update:icon", {"Icon": dat.icon, "Color": dat.color, "Size": dat.size, "Show": this.icon.Show});
            }
        },
        computed:
        {
            BlockProps: function(){
                return this.blockprops;
            }
        },
        beforeMount: function () {

        },
        mounted: function () {
            this.IconColor = this.icon.Color;
        },
        beforeUnmount: function () {

        }
    }
</script>
